import React, {useEffect, useState} from "react";
import "./follow-up-list.scss"
import newCallImage from "../icons/new-call.svg"
import {FollowUpListItem} from "./FollowUpListItem";
import {CompanyType} from "../../../types/company.type";
import {CustomLoader} from "../../../components/UI/CustomLoader/CustomLoader";
import Pagination from "../../../components/other/Pagination";
import {FollowUpListFilter} from "./FollowUpListFilter";
import {FollowUpModal} from "../FollowUpModal/FollowUpModal";
import {openPopupWidget} from "react-calendly";
import {ViewPageDuration} from "../../../components/other/ViewPageDuration/ViewPageDuration";
import {DeleteFollowUpModalConfirm} from "../DeleteFollowUpModalConfirm/DeleteFollowUpModalConfirm";
import {FollowUpTabs} from "../components/FollowUpTabs/FollowUpTabs";
import {useFollowUpList} from "./useFollowUpList";
import {BookNewFollowUpTypesItemType} from "../BookNewFollowUp/useBookNewFollowUp";
import {UpcomingCallModal} from "./UpcomingCallModal/UpcomingCallModal";
import {FollowUpModalSuccessUpcoming} from "./ModalsSuccess/FollowUpModalSuccessUpcoming";
import {FollowUpModalSuccessConducted} from "./ModalsSuccess/FollowUpModalSuccessConducted";
import ModalContainer from "../../../components/ModalContainer";
import {BusinessGoalType} from "../../BusinessGoals/BusinessGoal.type";
import {ReactSelect} from "../../../components/UI";
import customAxios from "../../../service/api/interceptors";
import {useHistory} from "react-router-dom";
import {ModalLoader} from "../../../components/other/ModalLoader/ModalLoader";
import {ExtraSelect} from "../../../components/UI/ExtraSelect/ExtraSelect";

export const FollowUpCallTypes: { [key: number]: string } = {
    0: "Onboarding Call",
    1: "Call with VLO",
    2: "Legal Discovery Session",
    3: "Legal Q&A Call",
    4: "Tax Discovery Session",
    5: "Data Privacy & Compliance"
}

export const followUpCallTypesArray = Object.entries(FollowUpCallTypes).map(([value, label]) => ({
    value, label
}));

export type FollowUpType = {
    company_id: number
    created_at: number
    date: number
    description: string
    id: number
    link: string
    status: number
    type: number
    follow_up_id: string
    company: CompanyType
    business_goals: { title: string, id: number }[]
    call_type: BookNewFollowUpTypesItemType
    follow_up?: FollowUpType
}

export const followUpColumnsWidth = [
    { flexGrow: 1 },
    { width: "140px", flexShrink: 0 },
    { width: "160px", flexShrink: 0 },
    { width: "225px", flexShrink: 0 },
]

export const dateMonthAgo = new Date();
dateMonthAgo.setMonth(dateMonthAgo.getMonth() - 1);

export const FollowUpList: React.FC = () => {
    const {
        items,
        loading,
        updateParam,
        searchParams,
        count,
        modalConfig,
        setModalConfig,
        getData,
        isClient,
        clientCallLink,
        userData,
        companies,
        isOpenDestroyModal,
        setIsOpenDestroyModal,
        destroyItem,
        creditCount,
        isCreateUpcomingCall,
        setIsCreateUpcomingCall,
        setIsSuccess,
        isSuccess,
        addFollowUpModal,
        setAddFollowUpModal,
        createFollowUpWithProject
    } = useFollowUpList()

    if (companies.length === 0) return <></>

    return (
        <>
            <div className={"follow-up-list"} style={{ maxWidth: !isClient ? "1200px" : "" }}>
                {userData?.status.type_code === 100 && <ViewPageDuration name={"view_follow_up_list"} data={{
                    user_id: userData?.user_id,
                    timestamp: (+(new Date()) / 1000).toFixed(),
                    company_id: companies[0]?.id
                }}/>}
                <div className="follow-up-list__content">
                    <h1>Expert Calls Hub</h1>
                    {(userData?.status.type_code === 100 && creditCount.isCreditSubscription) && <FollowUpTabs/>}
                    {(userData?.status.type_code === 300 || userData?.status.type_code === 400) && <FollowUpTabs/>}
                    <h2>Conducted CALLS</h2>
                    <FollowUpListFilter isClient={isClient} />
                    {
                        loading && <CustomLoader />
                    }
                    {!loading && items.length > 0 && <div className="follow-up-list__table">
                        <div className="follow-up-list__table-tr">
                            <div style={followUpColumnsWidth[0]} className="follow-up-list__table-th">Project</div>
                            <div style={followUpColumnsWidth[1]} className="follow-up-list__table-th">Type</div>
                            <div style={followUpColumnsWidth[2]} className="follow-up-list__table-th">When</div>
                            <div style={followUpColumnsWidth[3]} className="follow-up-list__table-th">Options</div>
                        </div>
                        {
                            (items || []).map(item => <FollowUpListItem
                                isClient={isClient}
                                key={item.id}
                                item={item}

                                toggleButton={(key) => {
                                    if (key === "edit") {
                                        setModalConfig({ id: item.id, data: item })
                                    } else if (key === "delete") {
                                        setIsOpenDestroyModal(item.id + "")
                                    } else if (key === "addCall") {
                                        if (item.business_goals.length > 0) {
                                            createFollowUpWithProject(item)
                                        } else {
                                            setAddFollowUpModal(item.id + "")
                                        }
                                    }
                                }}
                            />)
                        }
                    </div>}
                    {
                        items.length === 0 && !isClient && <p style={{ padding: "50px", textAlign: "center" }}>
                            Nothing to show
                        </p>
                    }
                    <div className={"flex justifyCenter"}>
                        {count > 10 && <Pagination
                            currentPage={Number(searchParams.get("page")) || 1}
                            pagesAmount={Math.ceil(Number(count) / 10)}
                            setCurrentPage={page => updateParam("page", page + "")}
                        />}
                    </div>
                    {items.length === 0 && isClient && <div className={"follow-up-list__not-found"}>
                        <div className="follow-up-list__not-found-heading">
                            Your Calls and Follow-Ups Will Appear Here
                        </div>
                        <p>
                            After your calls with our team, all key details and follow-up information will be displayed
                            here.
                            <br/><br/>
                            Check back soon to stay updated!
                        </p>
                    </div>}
                </div>
                {!isClient && <div className="follow-up-list__new-call" style={{ marginTop: "65px" }}>
                    <img src={newCallImage} alt=""/>

                        <button onClick={() => setIsCreateUpcomingCall(true)} className={"btn-black w100 text-uppercase"}>
                            ADD new call
                        </button>
                </div>}

            </div>
            <FollowUpModal
                isOpen={!!modalConfig}
                id={modalConfig?.id}
                data={modalConfig?.data}
                close={(key) => {
                    setModalConfig(null)
                    if (key) getData()
                }}
            />
            <UpcomingCallModal
                hideUpcomingFields={true}
                isOpen={isCreateUpcomingCall}
                closeModal={() => setIsCreateUpcomingCall(false)}
                refresh={() => {
                    setIsCreateUpcomingCall(false)
                    getData()
                }}
                setSuccess={() => setIsSuccess(true)}
            />
            <FollowUpModalSuccessConducted
                isOpen={isSuccess}
                close={() => setIsSuccess(false)}
            />
            <DeleteFollowUpModalConfirm
                isOpen={!!isOpenDestroyModal}
                close={() => setIsOpenDestroyModal(null)}
                confirm={destroyItem}
            />
            <ConnectWithProjectModal
                isOpen={addFollowUpModal}
                close={() => setAddFollowUpModal("")}
                refresh={() => {
                    getData()
                    setAddFollowUpModal("")
                }}
                company_id={items.find(el => String(el.id) === String(addFollowUpModal))?.company_id}
            />
        </>
    )
}

const ConnectWithProjectModal: React.FC<any> = ({ isOpen, close, refresh, company_id }) => {
    const [projects, setProjects] = useState<BusinessGoalType[]>([])
    const [projectId, setProjectId] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)
    const history = useHistory()

    const getBg = async () => {
        setLoading(true)
        const { status, data } = await customAxios.get(`/company/${company_id}/business-goals`)
        if (status === 200) {
            setProjects(data)
        }
        setLoading(false)
    }

    useEffect(() => {
        if (isOpen && company_id) {
            getBg()
        } else {
            setProjectId("")
            setProjects([])
        }
    }, [isOpen]);

    const createFollowUp = async () => {
        setLoading(true)
        const { status, data } = await customAxios.post(`/call-follow-up`, {
            call_id: isOpen,
            business_goal_id: [projectId],
        })
        if (status === 200) {
            refresh()
        }
        setLoading(false)
    }

    return (
        <div className={"follow-up-modal"}>
            <ModalContainer isOpen={!!isOpen} close={close}>
                <div className={"relative"}>
                    {loading && <ModalLoader />}
                    <h3 style={{ marginTop: "-25px" }}>CREATE FOLLOW-UP</h3>
                    {projects.length === 0 && <div>
                        <p style={{ fontFamily: "Inter", fontSize: "15px", fontWeight: 400, textAlign: "center", margin: "35px auto 10px auto", maxWidth: "400px" }}>There are no projects available. To create a call, you must add a project.</p>
                        <button onClick={() => history.push(`/legal-projects?client=${company_id}`)} className={"btn-black w100 mt10"}>ADD PROJECT</button>
                    </div>}
                    {projects.length > 0 && <div>
                        <ExtraSelect
                            className={"mt40"} hideSearch={true}
                            label={"Select a project"}
                            value={projectId}
                            options={projects.map(el => ({value: el.id + "", label: el.title}))}
                            onClick={e => setProjectId(e.target.value)}
                        />
                        <button disabled={!projectId} onClick={createFollowUp} className={"btn-black w100 mt10"}>CREATE FOLLOW-UP</button>
                    </div>}
                </div>
            </ModalContainer>
        </div>
    )
}